import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import AboutHero from './components/AboutHero';
import PrinciplesSection from './components/PrinciplesSection';
import VoicesSection from './components/VoicesSection';
import ContactForm from './components/ContactForm';

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'AboutPage',
      name: '关于剧真档案',
      url: 'https://aceasia.cn/about',
      inLanguage: 'zh-CN',
      description:
        '剧真档案的网站定位、内容原则、信源分级标准与联系方式。专注爆料短剧真实事件改编确认与改编程度分析。',
    },
    {
      '@type': 'ContactPage',
      name: '联系剧真档案',
      url: 'https://aceasia.cn/about#contact',
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://aceasia.cn/' },
        {
          '@type': 'ListItem',
          position: 2,
          name: '关于我们',
          item: 'https://aceasia.cn/about',
        },
      ],
    },
  ],
};

export default function About() {
  useEffect(() => {
    document.title = '关于我们｜内容原则与信源分级 - 剧真档案';
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 pt-16 md:pt-[72px]">
        <AboutHero />
        <PrinciplesSection />
        <VoicesSection />
        <ContactForm />
      </main>
      <Footer />
      <BackToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutJsonLd) }}
      />
    </div>
  );
}